
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { FontItem } from "./store/types";

const SystemModule = namespace("system");

@Options({
  components: {},
})
export default class App extends Vue {

  @SystemModule.Getter("getFontList")
  private getFontList!: FontItem[];

  @SystemModule.Getter("getLocalFontId")
  private localFontId!: number;

  public storedFontClassName = "";

  public mounted() {
    const fontItem = this.getFontList.find(
      (item) => item.family === localStorage.getItem("fontFamily")
    );
    if (fontItem) {
      this.storedFontClassName = fontItem.tag;
    }
  }

  @Watch("localFontId")
  public onChangeLocalFontId(value: number) {
    const fontItem = this.getFontList.find((item) => item.id === value);
    if (fontItem) {
      localStorage.setItem("fontFamily", fontItem.family);
      this.storedFontClassName = fontItem.tag;
    }
  }
}
